import Vue from 'vue'
import Router from 'vue-router'
import Home from "@/views/Home.vue";
import Index from "@/views/Index.vue";
import projectList from "@/views/project/projectList.vue";
import projectDetail from "@/views/project/projectDetail.vue";
import Detail from "@/views/project/Detail.vue";
import login from "@/views/login.vue";
import Certification from "@/views/certification.vue";
import Service from "@/views/service.vue";
import Inspection from "@/views/Inspection.vue";
import queryList from "@/views/query/queryList.vue";
import personal from "@/views/personal.vue";
import about from "@/views/about.vue";

Vue.use(Router)

// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = Router.prototype.push
 
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const routes = [
  {
    path: "/home",
    name: "home",
    component: Home,
    children: [
      {
        path: 'login',
        component: login,
        meta: {
          title: "登录"
        }
      },
      {
        path: 'index',
        component: Index,
        meta: {
          title: "山西华晋工程担保"
        }
      },
      {
        path: 'certification',
        component: Certification,
        meta: {
          title: "企业认证"
        }
      },
      {
        path: 'service',
        component: Service,
        meta: {
          title: "保函服务"
        }
      },
      {
        path: 'inspection',
        component: Inspection,
        meta: {
          title: "保函查验"
        }
      },
      {
        path: 'projectList',
        component: projectList,
        meta: {
          title: "项目查询"
        }
      },
      {
        path: 'queryList',
        component: queryList,
        meta: {
          title: "保函查询"
        }
      },
      {
        path: 'projectDetail',
        component: projectDetail,
        meta: {
          title: "项目详情"
        }
      },
      {
        path: 'Detail',
        component: Detail,
        meta: {
          title: "项目详情"
        }
      },
      {
        path: 'personal',
        component: personal,
        meta: {
          title: "个人中心"
        }
      },
      {
        path: 'about',
        component: about,
        meta: {
          title: "关于我们"
        }
      }
      
    ]
  },
  { path: '*', redirect: '/home/login' }
];

const router = new Router({
  routes: routes,
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

export default router;


// WEBPACK FOOTER //
// ./src/router/index.js